export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1.5 h-7 rounded-full bg-primary-500" />
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">联系我们</h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-10 lg:p-12">
          <div className="flex-1">
            <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-3">
              有问题或建议？欢迎联系我们
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              91免费视频网站重视每一位用户的反馈。无论是91免费在线视频的内容推荐建议，还是91麻豆免费视频网站的技术问题反馈，亦或是91福利视频在线的合作咨询，都可以通过以下方式与我们取得联系。我们的编辑与技术支持团队会在24小时内认真阅读并处理您的每一条留言。
            </p>

            <div className="space-y-5 mb-8">
              <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100">
                <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center shrink-0">
                  <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                    <i className="ri-mail-line text-lg" />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">邮箱咨询</p>
                  <p className="text-xs text-foreground-500 mt-0.5">support@91shipin.example</p>
                  <p className="text-[11px] text-foreground-400 mt-0.5">适用于合作、版权与商务联系</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100">
                <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center shrink-0">
                  <div className="w-5 h-5 flex items-center justify-center text-accent-600">
                    <i className="ri-time-line text-lg" />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">响应时效</p>
                  <p className="text-xs text-foreground-500 mt-0.5">常规咨询24小时内回复</p>
                  <p className="text-[11px] text-foreground-400 mt-0.5">紧急问题优先处理通道</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100">
                <div className="w-12 h-12 rounded-xl bg-secondary-50 flex items-center justify-center shrink-0">
                  <div className="w-5 h-5 flex items-center justify-center text-secondary-600">
                    <i className="ri-chat-3-line text-lg" />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">投稿合作</p>
                  <p className="text-xs text-foreground-500 mt-0.5">欢迎优质视频内容创作者联系</p>
                  <p className="text-[11px] text-foreground-400 mt-0.5">编辑团队审核后安排展示位</p>
                </div>
              </div>
            </div>

            <div className="rounded-xl bg-background-100 p-5 border border-background-200/50">
              <p className="text-sm text-foreground-600 leading-relaxed">
                <strong className="text-foreground-800">内容推荐与投稿：</strong>
                如果您有优质的91免费在线视频资源、91麻豆免费视频网站内容或91福利视频在线作品希望推荐，欢迎通过上方邮箱联系。我们的编辑团队会认真审核每一份推荐，并在通过后为您安排首页展示位。
              </p>
            </div>
          </div>

          <div className="flex-1">
            <div className="rounded-xl border border-background-200/70 bg-background-100 p-6 md:p-8 space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-2">
                  您的邮箱
                </label>
                <div className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300/60 bg-background-50 text-foreground-400">
                  请输入您的邮箱地址
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-2">
                  咨询内容
                </label>
                <div className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300/60 bg-background-50 text-foreground-400 h-28">
                  请描述您的问题或建议（不超过500字）
                </div>
              </div>

              <div className="rounded-lg bg-accent-50 p-3 text-sm text-accent-700">
                <div className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-information-line" />
                  </div>
                  <p>请通过上方邮箱地址联系我们，编辑团队会在24小时内回复您的消息。本站表单为快速入口展示，实际沟通请以邮件为准。</p>
                </div>
              </div>

              <button
                type="button"
                className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
                onClick={() => {
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
              >
                <i className="ri-mail-send-line" />
                通过邮箱联系
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}